var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHotTub = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M9.5 14.339c0-.252.205-.456.458-.456h20.083c.254 0 .459.204.459.456v1.32a.456.456 0 0 1-.459.454H9.958a.456.456 0 0 1-.458-.454v-1.32ZM29.494 16.19v8.854a.46.46 0 0 1-.46.456h-18.07a.46.46 0 0 1-.46-.456V16.19M25.696 25.216V16.19M14.302 16.19v9.026M18.1 25.216V16.19M21.898 16.19v9.026"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  d: "M16.06 5.5c-.028.031-.688.77-.688 1.633 0 .835.618 1.571.681 1.644l.004.006c.005.006.576.661.576 1.369 0 .699-.566 1.338-.575 1.348M20.057 5.5c-.027.031-.687.77-.687 1.633 0 .835.618 1.571.68 1.644l.004.006c.006.006.576.661.576 1.369 0 .699-.564 1.338-.574 1.348M24.056 5.5c-.028.031-.687.77-.687 1.633 0 .835.617 1.571.68 1.644l.004.006c.005.006.575.661.575 1.369 0 .699-.564 1.338-.573 1.348"
}))));
export default SvgHotTub;